export const LoaderButtonStates = {
  initial: 'waiting',
  loading: 'inProgress',
  done: 'done',
  error: 'error',
};
